<template>
    <!-- eslint-disable  -->
    <div class="input-group" :style="fieldStyles()">
      <field-icon :fieldData="fieldData"></field-icon>
      <input
        :disabled="(!!showDisabled())"
        :type="PasswordHidden ? 'password' : 'text'"
        :ref="fieldData.field_name"
        :id="fieldData.field_name"
        :name="fieldData.field_name"
        v-model="fieldData.field_value"
        v-validate="field_rules"
        @focus="$event.target.select()"
        @blur="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) :  ''"
        :placeholder="fieldData.placeholder"
        :maxlength="fieldData.max_length"
        autocomplete="off"
        v-bind:class="{'form-control': true,
          'error': errors.has(fieldData.field_name) || fieldData.has_error}">
        <i @click="passwordToggle()"  :class="(PasswordHidden ? 'fas fa-eye revealer' : 'fas fa-eye-slash revealer')"></i>
        <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
    </div>
</template>

<script>
/* eslint-disable */
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'sendPostRule'],
  components: { FieldIcon },
  mixins: [inputFieldMixin],
  data() {
    return {
      PasswordHidden : true,
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
    passwordToggle() {
      this.PasswordHidden = !this.PasswordHidden;
    },
  },
};
</script>

<style scoped>
  input[type="password"] {    
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
  }
  .fas.revealer {
    position: relative;
    top: 6px;
    right: 24px;
    color: #949494;
    z-index: 9;
  }
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputTextpii.vue?22367f12